import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComment = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "outline",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.5 16C21.5 17.1046 20.6046 18 19.5 18H8.5L6.1 21.2C5.58348 21.8887 4.68423 22.1696 3.86754 21.8974C3.05086 21.6251 2.5 20.8609 2.5 20V5C2.5 3.89543 3.39543 3 4.5 3H19.5C20.6046 3 21.5 3.89543 21.5 5V16Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "content",
			d: "M19.5 16H7.5L4.5 20V5H19.5V16Z",
			fill: "#2699FB"
		})
	]
});
export default SvgComment;
